<template>
  <div v-if="modalVisible">
    <transition name="modal-fade">
      <div class="modal-backdrop-jaleko-nps" >
        <div class="modal-jaleko-nps"
          role="dialog"
          aria-labelledby="modalTitle"
          aria-describedby="modalDescription"
        >
          <div class="modal-nps-close">
            <button type="button" class="close" aria-label="Close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="text-center">
            <ScoreComponent v-on:update-score="updateScore" v-on:update-commentary="updateCommentary" :scoreProps="score" :companyName="companyName"/>
            <ReasonOfScoreComponent v-on:update-reasonOfScore="updateReasonOfScore" :reasonOfScoreProps="reasonOfScore" :companyName="companyName" :commentary="commentary"/>
            <b-button class="mt-4 btn btn-secondary" @click="closeModal" >Enviar resposta</b-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>

import ReasonOfScoreComponent from '@/modules/Nps/ReasonOfScore'
import ScoreComponent from '@/modules/Nps/Score'
import NpsApi from '@/api/nps-api'

export default {
  data () {
    return {
      score: null,
      reasonOfScore: '',
      npsId: null,
      canAnswerInThisMonth: false,
      modalVisible: false,
      commentary: false
    }
  },
  components: {
    ReasonOfScoreComponent, ScoreComponent
  },
  props: {
    name: {
      type: String,
      required: true
    },
    token: {
      type: String,
      required: true
    },
    baseUrlToAnwserNps: {
      type: String,
      required: true
    },
    baseUrlInitializedNps: {
      type: String,
      required: true
    },
    companyName: String,
    description: String
  },
  async mounted () {
    console.log('Nps Modal opened')
    this.initializeLocalStorage()
    this.verifyIfCanShowModal()
  },
  methods: {
    updateCommentary () {
      this.commentary = true
    },
    updateScore (score) {
      this.score = score
    },
    updateReasonOfScore (reasonOfScore) {
      this.reasonOfScore = reasonOfScore
    },
    closeModal () {
      this.modalVisible = false
      this.answerNps()
    },
    initializeLocalStorage () {
      localStorage.setItem('tokenAccessUserNps', this.token)
      localStorage.setItem('baseUrlNps', this.baseUrlToAnwserNps)
    },
    async verifyIfCanShowModal () {
      /* eslint-disable */
      try {
        let { pode_responder_nps_esse_mes, nps_id } = await NpsApi.checkIfUserCanAnswerNpsAndCreate(this.baseUrlInitializedNps)

        this.canAnswerInThisMonth = pode_responder_nps_esse_mes
        this.npsId = nps_id
        if (this.canAnswerInThisMonth) {
          this.modalVisible = true
        }
      } catch (error) {
        console.log(error)
      }
    },
    async answerNps () {
      try {
        if (this.score != null) {
          let nps = {
            nps_id: this.npsId,
            pontuacao: parseInt(this.score),
            motivo_pontuacao: this.reasonOfScore
          }
          NpsApi.answerNps(nps)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>
